import React from "react"
import icon from "images/layout/chevron-right-white.svg"

export default function ChevronRightIcon() {
  return (
    <span className="svg-icon" dangerouslySetInnerHTML={{ __html: icon }} />
  )
}
